import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import Button from '../ui/Button';
import AuthLayout, { PasswordField } from '../shell/AuthLayout';

// HD-4: Portal profile on src/ui (DESIGN rev 2.1 §3.3). Same checks and change-password call as before.
// HD-7 (HD-5 P3): two readings. A forced first-login change (user.mustChangePassword) keeps the "Set your password"
// copy and goes on to the dashboard; a voluntary change (from Account) reads "Change password" and returns to /account.
export default function ChangePassword() {
  const { user, clearMustChangePassword } = useAuth();
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const forced = !!user?.mustChangePassword;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) { setError('The two new passwords do not match.'); return; }
    if (newPassword.length < 8) { setError('Use at least 8 characters for the new password.'); return; }
    if (newPassword === currentPassword) { setError('Choose a new password that differs from the current one.'); return; }
    setLoading(true);
    try {
      const res = await api.post('/api/auth/change-password', { currentPassword, newPassword });
      clearMustChangePassword(res.data.accessToken, res.data.refreshToken, res.data.user);
      navigate(forced ? '/dashboard' : '/account', { replace: true });
    } catch (err) {
      setError(err?.response?.data?.error || 'The password did not change. Check the connection and try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout>
      <h1 className="ui-auth__title">{forced ? 'Set your password' : 'Change password'}</h1>
      <p className="ui-auth__lede">{forced
        ? `${user?.name ? `${user.name.split(' ')[0]}, your` : 'Your'} account needs a new password before you continue.`
        : 'Enter your current password, then the new one twice.'}</p>
      <form className="ui-auth__form" onSubmit={handleSubmit}>
        <PasswordField label="Current password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} hint={forced ? 'The temporary password you were sent' : 'Your current password'} required autoComplete="current-password" autoFocus />
        <PasswordField label="New password" value={newPassword} onChange={e => setNewPassword(e.target.value)} hint="At least 8 characters" required autoComplete="new-password" />
        <PasswordField label="Confirm new password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required autoComplete="new-password" />
        {error && <p className="ui-auth__alert" role="alert">{error}</p>}
        <Button type="submit" variant="primary" portal loading={loading}>{forced ? 'Set new password' : 'Change password'}</Button>
      </form>
      {!forced && <Link className="ui-auth__link" to="/account">Back to account</Link>}
    </AuthLayout>
  );
}
